import { useQuery } from "@tanstack/react-query";
import { useLocation, useParams } from "react-router-dom";
import React, { useState } from "react";
import { getAxiosImportServer } from "../../shared/Services/importService";
import { IMPORT_GET_MATCHODDS } from "../../utils/api/ApiConstant";
import { Button, DataTable, SubHeading, Switch } from "../../shared/Components";
import { CommonModal, ImportConfigModal } from "../../shared/Components/Modal";

const ImportStep4 = () => {
  const [isShow, setIsShow] = useState({
    isOpen: false,
    rowData: null,
    name: "",
    modalTitle: "",
    modalContent: null,
    apiFlag: false,
  });

  const location = useLocation();
  const rowData = location.state;
  const { id, source } = useParams();
  const { isLoading, data } = useQuery({
    queryKey: ["importMatchOddsData"],
    queryFn: async () =>
      await getAxiosImportServer(`${IMPORT_GET_MATCHODDS}/${source}`, {
        event_id: id,
      }),
  });

  const fetchData = () => {
    if (!data) return { data: [], pages: 0 };

    return {
      data: data?.data,
      pages: data?.pages,
    };
  };

  const columns = [
    {
      accessorKey: "name",
      header: "Name",
    },
    {
      accessorKey: "exists",
      header: "Import",
      cell: ({ getValue, row }) => {
        return <Switch getValue={getValue} disabled={true} />;
      },
    },
  ];

  return (
    <>
      <SubHeading
        subTitle="Game Import Step-4"
        isAddBtnPage={false}
        isAddBtn={false}
        redirectPath="create"
        isBack={true}
      />
      <div className="card-body">
        <DataTable
          columns={columns}
          data={data?.data}
          isSearchable={false}
          isPagination={false}
          isPageSize={false}
          // currentPage={currentPage}
          // onPageChange={handlePageChange}
          // onRecordsPerPageChange={handleRecordsperPage}
          // recordsPerPage={recordsPerPage}
          // onSearchChange={handleSearch}
          // searchTerm={searchTerm}
          isLoading={isLoading}
          // handleHeaderSort={handleHeaderSort}
        />
      </div>

      <CommonModal
        isShow={isShow.isOpen}
        handleShowHide={() =>
          setIsShow((prev) => ({
            ...prev,
            isOpen: false,
            rowData: {},
            name: "",
          }))
        }
        modalTitle={isShow.modalTitle}
      >
        {isShow.modalContent &&
          React.createElement(isShow.modalContent, {
            handleShowHide: () =>
              setIsShow((prev) => ({
                ...prev,
                isOpen: false,
                rowData: {},
                name: "",
                modalTitle: "",
                apiFlag: !prev.apiFlag,
              })),
            rowData: { ...rowData, rowData: isShow.rowData },
          })}
      </CommonModal>
    </>
  );
};

export default ImportStep4;
